var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperCardArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4857 10.8133C13.6648 10.6378 13.6677 10.3502 13.4922 10.1711L10.6314 7.25186C10.4558 7.07272 10.1683 7.06981 9.98915 7.24537C9.81001 7.42092 9.80711 7.70845 9.98266 7.88759L12.5256 10.4825L9.93072 13.0254C9.75158 13.2009 9.74867 13.4885 9.92423 13.6676C10.0998 13.8467 10.3873 13.8496 10.5664 13.6741L13.4857 10.8133ZM8.09082 10.4376L8.08623 10.8917L13.1632 10.9431L13.1678 10.4889L13.1724 10.0348L8.09541 9.9835L8.09082 10.4376Z",
    fill: "#1C2E1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperCardArrow);
export default __webpack_public_path__ + "static/media/Paper-card-arrow.830476a3bc1e973fef0002054dc22ee9.svg";
export { ForwardRef as ReactComponent };